import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { Card } from '../ui/Card';
interface SponsorsSectionProps {
  variant?: 'compact' | 'full';
}
const sponsors = [{
  name: 'Dra. Ysailis Martínez',
  role: 'Obstetricia & Ginecología',
  instagram: '@draysailismartinez',
  instagramUrl: 'https://instagram.com/draysailismartinez',
  logo: 'https://cdn.magicpatterns.com/uploads/dNrU7FCbbbGpDCV4tCUqHz/logo_Dra_Ysalismar.png'
}, {
  name: 'Centro Médico Especializado Profem',
  role: 'Centro Médico Avalado',
  instagram: '@profemm.ccs',
  instagramUrl: 'https://instagram.com/profemm.ccs',
  logo: 'https://cdn.magicpatterns.com/uploads/eU8PbVGmVaCumSpkp7nv1z/Logo_Centro_medico_Especializado_Profem.jpg'
}];
export function SponsorsSection({
  variant = 'full'
}: SponsorsSectionProps) {
  if (variant === 'compact') {
    return <section className="py-10 bg-beige border-y border-beige" data-id="element-230">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
          <p className="text-center text-xs font-body uppercase tracking-[0.2em] text-taupe-light mb-8" data-id="element-232">
            Avalado por
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16" data-id="element-233">
            {sponsors.map(s => <a key={s.name} href={s.instagramUrl} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 text-taupe hover:text-gold transition-colors" data-id="element-234">
                <div className="w-16 h-16 rounded-full bg-white border border-beige flex items-center justify-center overflow-hidden flex-shrink-0 group-hover:border-gold transition-colors shadow-sm" data-id="element-235">
                  <img src={s.logo} alt={`Logo ${s.name}`} className="w-full h-full object-contain p-1.5" data-id="element-236" />
                </div>
                <div className="text-left" data-id="element-237">
                  <p className="font-heading font-bold text-sm leading-tight" data-id="element-238">
                    {s.name}
                  </p>
                  <p className="text-xs font-body text-taupe-light group-hover:text-gold transition-colors" data-id="element-239">
                    {s.instagram}
                  </p>
                </div>
              </a>)}
          </div>
        </div>
      </section>;
  }
  // Full variant
  return <section className="py-20 bg-beige" data-id="element-240">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <div className="text-center mb-12" data-id="element-242">
          <span className="inline-block px-4 py-1 rounded-full border border-gold/30 text-gold text-sm font-body tracking-widest uppercase mb-4" data-id="element-243">
            Respaldo Profesional
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-244">
            Avalado por profesionales de la salud
          </h2>
          <p className="text-lg font-body text-taupe-light max-w-2xl mx-auto" data-id="element-245">
            Este método cuenta con el respaldo de especialistas en salud
            hormonal femenina.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-246">
          {sponsors.map(s => <Card key={s.name} variant="elevated" className="p-8 text-center flex flex-col items-center" data-id="element-247">
              <div className="w-32 h-32 rounded-2xl bg-white flex items-center justify-center mb-6 overflow-hidden shadow-sm border border-beige" data-id="element-248">
                <img src={s.logo} alt={`Logo ${s.name}`} className="w-full h-full object-contain p-3" data-id="element-249" />
              </div>
              <h3 className="font-heading text-xl font-bold text-taupe mb-2" data-id="element-250">
                {s.name}
              </h3>
              <p className="font-body text-sm text-taupe-light mb-5" data-id="element-251">
                {s.role}
              </p>
              <a href={s.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-taupe text-cream font-body text-sm font-medium hover:bg-gold transition-colors" data-id="element-252">
                <InstagramIcon className="w-4 h-4" data-id="element-253" />
                {s.instagram}
              </a>
            </Card>)}
        </div>
      </div>
    </section>;
}